import { colorPallet } from 'src/styles/theme/colors';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';

export const avatarColors = [
  '#45151A',
  '#87511A',
  '#4C311E',
  '#307040',
  '#183A0F',
  '#0D2C4B',
  '#451552',
  '#762A5B',
  '#212427',
  '#2A656C',
];

export const avatarBackgroundColors = [
  '#CD9EA5',
  '#FADEB8',
  '#D9C4B2',
  '#B7EECF',
  '#A6D09F',
  '#A1BED9',
  '#D1AADC',
  '#EFC3E1',
  '#BDC3C7',
  '#B4E7EC',
];

type IPieChartStyle = {
  firstThreeEmployeeColors: {
    color: string;
    background: string;
  }[];
};

export const TeamVacationSquare = styled.div<{
  currentUserHasVacation: boolean;
}>`
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 5px;
  background: ${({ currentUserHasVacation }) =>
    currentUserHasVacation && !isMobile ? colorPallet.richBlue : 'transparent'};
  top: 0;
`;

export const DayStringStyled = styled.p`
  color: #ffffff;
`;

export const TeamVacationCircleContainer = styled.div<IPieChartStyle>`
  position: absolute;
  z-index: 1;
  top: -0.5rem;
  left: 50%;
  [class*='fui-AvatarGroup'] {
    div:nth-child(3) {
      > span {
        > span {
          color: transparent;
          background: ${({ firstThreeEmployeeColors }) =>
            firstThreeEmployeeColors.length > 2
              ? firstThreeEmployeeColors[2].background
              : 'transparent'};
          ::before {
            margin-left: 0.3rem;
            margin-bottom: 0.1rem;
            font-weight: 700;
            color: ${({ firstThreeEmployeeColors }) =>
              firstThreeEmployeeColors.length > 2
                ? firstThreeEmployeeColors[2].color
                : 'transparent'};
            content: '+';
          }
        }
      }
    }
    div:nth-child(2) {
      > span {
        > span {
          color: ${({ firstThreeEmployeeColors }) =>
            firstThreeEmployeeColors.length > 1
              ? firstThreeEmployeeColors[1].color
              : 'transparent'};
          background: ${({ firstThreeEmployeeColors }) =>
            firstThreeEmployeeColors.length > 1
              ? firstThreeEmployeeColors[1].background
              : 'transparent'};
        }
      }
    }
    div:nth-child(1) {
      > span {
        > span {
          color: ${({ firstThreeEmployeeColors }) =>
            firstThreeEmployeeColors.length > 0
              ? firstThreeEmployeeColors[0].color
              : 'transparent'} !important;
          background: ${({ firstThreeEmployeeColors }) =>
            firstThreeEmployeeColors.length > 0
              ? firstThreeEmployeeColors[0].background
              : 'transparent'};
        }
      }
    }
  }
`;

export const AvatarCircle = styled.div<{ background: string; color: string }>`
  width: ${() => (!isMobile ? '22.5px' : '2.1rem')};
  height: ${() => (!isMobile ? '22.5px' : '2.1rem')};
  border-radius: 50%;
  background: ${(props) => props.background};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${() => (!isMobile ? '0.6rem' : '1.5rem')};
    font-weight: 600;
    color: ${(props) => props.color};
  }
`;

export const PopupListContainer = styled.ul`
  max-height: 150px;
  overflow-y: scroll;
  list-style: none;
  background: ${(props) => props.theme.vaccationIndicatorPopupBackground};
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  font-size: 0.6rem;
  li {
    span {
      display: flex;
      align-items: flex-start;
      gap: 0.4rem;
    }
    font-weight: 600;
    font-size: 0.7rem;
    padding: 0.2rem;
    padding-left: 0.5rem;
    color: ${(props) => props.theme.calendarDateColor};
    display: flex;
    align-items: center;
    @media (max-width: 1072px) {
      zoom: 0.9;
      height: 3rem;
    }
  }
  li + li {
    border-top: 1px solid ${colorPallet.darkGray};
  }
`;

export const CurrentUserVaccation = styled.li<{
  isOnlyCurrentUserOnVacation: boolean;
}>`
  background: ${(props) => props.theme.currentUserVacationBackgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 0.7rem;
  padding: 0.1rem;
  padding-left: 0.5rem;
  color: #000000;
  border-bottom-right-radius: ${({ isOnlyCurrentUserOnVacation }) =>
    isOnlyCurrentUserOnVacation ? '0.5rem' : '0'};
  border-bottom-left-radius: ${({ isOnlyCurrentUserOnVacation }) =>
    isOnlyCurrentUserOnVacation ? '0.5rem' : '0'};
`;

export const TeamMembersDropDown = styled.div<{ position: 'top' | 'bottom' }>`
  zoom: 0.9;
  position: absolute;
  border-radius: 0.5rem;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
  ${({ position }) => {
    if (position === 'top') {
      return 'top: 0;';
    }
    return 'bottom: 2rem;';
  }}
  left: -1rem;
  width: 9.1rem;
  z-index: 10;

  @media (max-width: 1072px) {
    width: 7rem;
  }
`;

export const TeamDetailsHeader = styled.div`
  color: ${(props) => props.theme.calendarDateColor};
  height: 35px;
  font-size: 0.8rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  background: ${(props) =>
    props.theme.vaccationIndicatorTeamDetailsHeaderBackground};
  text-align: left;
  padding: 0.15rem;
  padding-left: 0.5rem;
  font-weight: 600;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
  @media (max-width: 1072px) {
    zoom: 0.9;
  }
`;
